/** Fichas técnicas PDF (marketing.montironi.com/fichas/gac/). */
const FICHA_PDFS = {
  emkoo: "https://marketing.montironi.com/fichas/gac/emkoo.pdf",
  gs8: "https://marketing.montironi.com/fichas/gac/gs8.pdf",
  empow: "https://marketing.montironi.com/fichas/gac/empow.pdf",
  "gs3 emzoom": "https://marketing.montironi.com/fichas/gac/gs3_emzoom.pdf",
  "gs3-emzoom": "https://marketing.montironi.com/fichas/gac/gs3_emzoom.pdf",
  emzoom: "https://marketing.montironi.com/fichas/gac/gs3_emzoom.pdf",
  "gac-emkoo": "https://marketing.montironi.com/fichas/gac/emkoo.pdf",
  "gac-gs8": "https://marketing.montironi.com/fichas/gac/gs8.pdf",
  "gac-empow": "https://marketing.montironi.com/fichas/gac/empow.pdf",
  "gac-gs3-emzoom": "https://marketing.montironi.com/fichas/gac/gs3_emzoom.pdf",
};

/** Aion UT: landing online (no PDF). */
const FICHA_ONLINE = {
  "aion ut": "https://oficial.montironi.com/gac/aion-ut/",
  "aion-ut": "https://oficial.montironi.com/gac/aion-ut/",
  aion: "https://oficial.montironi.com/gac/aion-ut/",
  "gac-aion-ut": "https://oficial.montironi.com/gac/aion-ut/",
};

const LABEL_PDF = "Ver Ficha";
const LABEL_ONLINE = "Ver Ficha Online";

const normalizeKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const resolveKey = ({ modelo, id } = {}) => {
  const candidates = [normalizeKey(id), normalizeKey(modelo), normalizeKey(modelo).replace(/\s+/g, "-")];
  return candidates.find((key) => key && (FICHA_ONLINE[key] || FICHA_PDFS[key])) || null;
};

/**
 * Resuelve link de ficha para un vehículo GAC.
 * @returns {{ href: string, label: string }|null}
 */
export const getFichaLink = ({ modelo, id } = {}) => {
  const key = resolveKey({ modelo, id });
  if (!key) return null;

  if (FICHA_ONLINE[key]) {
    return { href: FICHA_ONLINE[key], label: LABEL_ONLINE };
  }

  return { href: FICHA_PDFS[key], label: LABEL_PDF };
};

/** @deprecated Preferí getFichaLink */
export const getFichaUrl = (vehicle) => getFichaLink(vehicle)?.href ?? null;
